import { useReducer } from 'react';
import componentReducer from './componentReducer';
import { init, setError, setValue, setValueLocalized } from './actions';

const useComponent = (initialData) => {
  const initialState = {
    error: false,
    data: initialData,
  };

  const [state, dispatch] = useReducer(componentReducer, initialState);

  const actions = {
    initializeComponent: (component) => {
      init(dispatch)(component);
    },

    setFormError: () => {
      setError(dispatch)();
    },

    setFormValue: (name, value) => {
      setValue(dispatch)(name, value);
    },

    setLocalizedValue: (name, value, language) => {
      setValueLocalized(dispatch)(name, value, language);
    },
  };

  return {
    data: state.data,
    error: state.error,
    actions,
  };
};

export default useComponent;
